import React,{useState,useEffect} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import { EditText, EditTextarea } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import AuthUser from "../AuthUser.jsx";
import AlertMessage from "../Utils/AlertMessage.jsx";
function Profile() {
  const { http, getUser, setUser } = AuthUser();
  let userdetails = getUser();
  const [formattedDate, setFormattedDate] = useState('');
  const [formData, setFormData] = useState({
    first_name: userdetails.first_name,
    email: userdetails.email,
    phone: userdetails.phone,
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [messagetype, setMessagetype] = useState(true);
  // Validation function  
  const validationRules = {
    first_name: {
      required: true,
      pattern: /^[a-zA-Z\s]{2,50}$/, // Matches only alphabetic characters and spaces, 2 to 50 characters
      message: "Name must be between 2 and 50 alphabetic characters only.",
    },
    mobile: {
      required: true,
      pattern: /^\d{10}$/,
      //regex: /^\d{10}$/,
      message: "Mobile number must be exactly 10 digits.",
    },
    url: {
      required: true,
      pattern: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/, // Basic URL regex
      message: "A valid URL is required. Example: https://example.com",
    },
    state: {
      required: true,
      pattern: /^[a-zA-Z\s]{2,50}$/, // Matches only alphabetic characters and spaces, 2 to 50 characters
      message: "City must be between 2 and 50 alphabetic characters only.",
    },
    city: {
      required: true,
      pattern: /^[a-zA-Z\s]{2,50}$/, // Matches only alphabetic characters and spaces, 2 to 50 characters
      message: "City must be between 2 and 50 alphabetic characters only.",
    },
    zipcode: {
      required: true,
      pattern: /^\d{5,6}$/,
      message: "Zip code must be 5 or 6 digits.",
    },
    addressline1: { regex: /^[a-zA-Z0-9\s,.-]{5,100}$/, pattern: /^.{5,100}$/, required: true },
    addressline2: { regex: /^[a-zA-Z0-9\s,.-]{5,100}$/, pattern: /^.{5,100}$/, required: true },
  };

  const validate = (field, value) => {

    const rule = validationRules[field];
    const errors = {};
    if (rule) {
      if (rule.required && !value) {
        errors[field] = rule.message;
      } else if (rule.pattern && !rule.pattern.test(value)) {
        errors[field] = rule.message;
      }
    }
    return errors;
  };

  const handleFieldSave = async ({ name, value }) => {

    // Validate the field before saving
    const validationErrors = validate(name, value);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      let fieldLabels = {
        'first_name': 'First Name',
        'mobile': 'Contact No.',
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Dynamically update the form field
      }));

      try {
        // Send the updated value to the backend API (Laravel)
        const response = await http.post(`agent/profileUpdate/${userdetails.email}`, {
          fieldname: name,
          updatevalue: value,
        });
        setUser(response.data.userdata)
        setMessage(`${fieldLabels[name]} updated successfully!`);
        setMessagetype('success')

      } catch (error) {
        setMessage(`Error updating ${fieldLabels[name]}. Please try again.`);
        setMessagetype('error')
        console.error(error);
      }
    }
  };
  useEffect(() => {
    if (userdetails && userdetails.created_at) {

      const cleanedDate = userdetails?.created_at.split('.')[0] + 'Z'; // remove everything after the period
      const date = new Date(cleanedDate);

      if (!isNaN(date)) {
        const formattedDate = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
        }).format(date);
        setFormattedDate(formattedDate);
      }

    }
  }, [userdetails])
  return (
    <Container fluid>



      <br /><br />
      <Card style={{ width: '33rem' }} className='m-auto rounded-0'>

        <Card.Body>
          <Card.Text >
            <Row>
              <Col>
                <div class="box-top">

                  <div class="profile">

                    <div class="profile-img">
                      <img src="https://cdn1.iconfinder.com/data/icons/user-pictures/101/malecostume-256.png" />
                    </div>

                    <div class="name-user">
                      <strong>My Profile</strong>

                    </div>
                  </div>


                </div>

              </Col>

            </Row>
            <Row>

              <Col>
                <Table striped bordered hover>

                  <tbody>
                    <tr>
                      <td className='fw-bold'>Name</td>
                      <td>
                        <EditText
                          name="first_name"
                          defaultValue={formData.first_name || ''}
                          onSave={handleFieldSave}
                          onChange={(value) => setFormData({ ...formData, first_name: value })}
                          editButtonProps={{ style: { marginLeft: '5px', width: 16 } }}
                          showEditButton
                        />

                      </td>

                    </tr>
                    <tr>
                      <td className='fw-bold'>Member since</td>
                      <td>
                        <EditText
                          name='textbox2'
                          defaultValue={formattedDate}
                          editButtonProps={{ style: { marginLeft: '5px', width: 16 } }}
                          readonly
                        />

                      </td>

                    </tr>


                    <tr>
                      <td className='fw-bold'> Email </td>
                      <td>
                        <EditText
                          name='textbox4'
                          defaultValue={userdetails.email}
                          editButtonProps={{ style: { marginLeft: '5px', width: 16 } }}
                          showEditButton
                          readonly
                        />


                      </td>

                    </tr>
                    <tr>
                      <td className='fw-bold'>Contact No </td>
                      <td>
                        <EditText
                          name="phone"
                          defaultValue={formData.phone || ''}
                          onSave={handleFieldSave}
                          onChange={(value) => setFormData({ ...formData, phone: value })}
                          editButtonProps={{ style: { marginLeft: '5px', width: 16 } }}
                          showEditButton
                        />
                      </td>

                    </tr>
                    <tr>
                      <td className='fw-bold'>Location</td>
                      <td>
                        <EditText
                          name='textbox6'
                          defaultValue={userdetails.name}
                          editButtonProps={{ style: { marginLeft: '5px', width: 16 } }}

                        />

                      </td>

                    </tr>
                  </tbody>
                </Table>

              </Col>
              <Col>



              </Col>
            </Row>
            <AlertMessage
              message={message}
              type={messagetype}
              timeout={3000} // Clear after 5 seconds
              onClear={() => setMessage("")} />
          </Card.Text>
        </Card.Body>
      </Card>

    </Container>

  );
}

export default Profile